import { Injectable, inject } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { LorenAuthenticationService } from "../../../../../shared/services/loren-authentication-service/loren-authentication.service";
import { LOREN_ROUTES } from "../../../../../shared/constants/loren-routes.constants";
import { LOREN_USER_ROLES } from "../../../../../shared/services/loren-authentication-service/constants/loren-user-roles.constants";

@Injectable({
  providedIn: "root",
})
export class LorenAdminGuard implements CanActivate {
  private authenticationService = inject(LorenAuthenticationService);
  private router = inject(Router);


  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.authenticationService.isAuthenticated()) {
      const roles = this.authenticationService.getRoles();
      if (
        roles.some((x) =>
          [
            LOREN_USER_ROLES.ADMIN,
            LOREN_USER_ROLES.ADMIN_READ,
            LOREN_USER_ROLES.CHANNEL_ADMIN_READ,
            LOREN_USER_ROLES.CHANNEL_ADMIN,
          ].includes(x)
        )
      ) {
        return true;
      } else {
        // TODO: redirect to 403 screen?
        this.router.navigate([LOREN_ROUTES.DASHBOARD]);
        return false;
      }
    } else {
      this.router.navigate([LOREN_ROUTES.LOGIN], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
  }
}
